import { render, staticRenderFns } from "./TerrenoProgrmas.vue?vue&type=template&id=654b1241&scoped=true&lang=html&"
import script from "./TerrenoProgrmas.vue?vue&type=script&lang=js&"
export * from "./TerrenoProgrmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b1241",
  null
  
)

export default component.exports